// @ts-strict-ignore
import NextImage from "components/parts/NextImage";
import styled from "styled-components";
import lightTheme from "themes/light";

export const MobileNavContainer = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  background: ${({ theme }) => theme.backgroundColors.primary};
  padding: 0 24px;
  z-index: 101;
  pointer-events: auto;
  flex-shrink: 0;

  ${({ theme: { media } }) => media.desktop`
    display: none;
  `}

  /* Account for iPhone 5 size screens */
  @media (max-width: 330px) {
    padding: 0 15px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  pointer-events:auto;
  button:first-of-type {
    width: 130px;
    height: 40px;

    @media (max-width: 600px) {
      width: 100px;
      height: 32px;
    }
  }

  button:nth-child(2) {
    margin-left: 16px;
    margin-top: 3px
    width: 25px;
  }
`;

export const CloseMenu = styled(NextImage).attrs((props) => ({
  src: props.src,
  height: 25,
  width: 25
}))`
  object-fit: contain;
`;

export const MenuItems = styled.ul`
  list-style-type: none;
  margin: 0 0 0 22px;
  padding: 0;
  li:last-child {
    margin-bottom: 0;
  }
`;

export const SubNavMenuItems = styled(MenuItems)`
  margin: 70px 0 0;
`;

export const MenuItem = styled.li<{ showArrow?: boolean }>`
  position: relative;
  font-stretch: normal;
  font-style: normal;
  // Avoid chaning font color when is dark theme
  color: ${lightTheme.textColors.primary};
  margin: ${({ showArrow }) => (showArrow ? "24px 0" : "0")};
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  &:last-of-type {
    &::before {
      left: -30px;
    }
  }

  ${({ showArrow }) =>
    showArrow &&
    `
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 18px;
      height: 16px;
      right: 20px;
      top: 26px;
      background: url(/static/images/careers-arrow.png) no-repeat center center;
      background-size: contain;
    }
  `};
`;

export const SubNavMenuItem = styled(MenuItem)`
  margin: 16px 0;
  &:last-child {
    &::before {
      left: 0;
    }
  }
`;

export const NonExpandingMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin: 0;
  padding-top: 32px;
`;
